import(/* webpackMode: "eager" */ "/vercel/path0/components/ContactCTA.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/EnhancedAboutHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseCard"] */ "/vercel/path0/components/ExpertiseCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ImpactShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/PersonalJourney.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
